import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  shopType: belongsTo('category', { inverse: null }),
  tradePartner: belongsTo('trade-partner', { inverse: null }),
  variantChannel: belongsTo('channel', { inverse: null }),
});
